var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333984 0.833984H9.50065V2.50065H0.333984V0.833984ZM0.333984 4.16732H9.50065V5.83398H0.333984V4.16732ZM0.333984 7.50065H6.16732V9.16732H0.333984V7.50065ZM13.0832 5.24398L9.49982 8.81982L8.42315 7.74398L7.24482 8.92315L9.49982 11.1765L14.2598 6.42398L13.0832 5.24398Z",
    fill: "#6A7187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendations);
export default __webpack_public_path__ + "static/media/recommendations.3d5d95af51669ca7a6c344f306172553.svg";
export { ForwardRef as ReactComponent };